import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import { sendResetPasswordEmail } from "src/services/AuthenticationAPIs";

const Resetpassword: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [emailError, setEmailError] = useState<string>("");

  // Regex to validate email format
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);
  const handleSendEmail = async (
    e: React.FormEvent<HTMLButtonElement>
  ): Promise<void> => {
    e.preventDefault();

    if (!emailRegex.test(email)) {
      setEmailError(
        "Please enter your email address in the format: datatram@example.com"
      );
      return;
    }

    setEmailError(""); // Clear any previous error
    setLoading(true); // Set loading state
    try {
      localStorage.setItem("email", email);
      const data = await sendResetPasswordEmail(email);
      setLoading(false);

      if (data.status) {
        message.success(
          data.message || "A password reset link has been sent to your email."
        );
        setTimeout(() => {
          navigate("/forgot-password/confirmation" , { state: { from: "forgot-password" } });
        }, 2000);
      } else {
        message.error(data.message || "An error occurred. Please try again.");
      }
    } catch {
      setLoading(false);
      message.error("Unable to connect to the server. Please try again later.");
    }
  };

  return (
    <>
      <div className="reset-pass-bg" style={{ backgroundImage: `url(/Icons/forget-password-bg.svg)` }}>
        <img src="/images/DpLogo.png" className="logo-design" alt="img" />
        <div className="app">
          <div className="signup-internal-container">
            <form className="formdesign">
              <img src="/images/userlock.png" className="user-lock" alt="userlock" />
              <h2 className="Reset-password">Reset Password</h2>
              <p className="Reset-detail">
                Enter your registered email address. You will receive an email
                to reset your password.
              </p>
              <div className="input-container">
                <label>
                  Email Address
                  <input
                    required
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    className={emailError ? "input-error" : ""}
                    disabled={loading}
                    type="email"
                  ></input>
                  <div className="error-message">{emailError}</div>
                </label>
              </div>
              <button
                className="button-otp"
                onClick={e => handleSendEmail(e)}
                disabled={loading}
              >
                {loading ? "Sending..." : "Send Email"}
              </button>

              <p className="signup-page-text viewTerms_text">
                Remember your password?&nbsp;
                <a href="/log-in">Sign In</a>
              </p>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Resetpassword;
